// prettier-ignore
import { anyone, adminOnly } from './access_defs';
import buildGqlQuery from './buildGqlQuery';

const vars = { id: 'ID!' };
const program = buildGqlQuery('reports_program', vars, 'acl:programGroupById(id: $id){ reportAccess }');
export const program_progressReports = buildGqlQuery('program_progressReports', vars, 'programGroupById(id: $id){ hasProgressReports }');
const district = buildGqlQuery('reports_district_whole', vars, 'acl:districtById(id: $id){ reportAccess }');
export const district_progressReports = buildGqlQuery('district_progressReports', vars, 'districtById(id: $id){ hasProgressReports }');
export const district_usageReports = buildGqlQuery('district_usageReports', vars, 'districtById(id: $id){ hasUsageReports }');
const district_districtSchools = buildGqlQuery('reports_district_districtSchools', vars, `districtById(id: $id){ districtSchools{ id } }`);
const district_nonDistrictSchools = buildGqlQuery('reports_district_nonDistrictSchools', vars, `districtById(id: $id){ districtSchools{ id } }`);
const school = buildGqlQuery('reports_school', vars, 'acl:schoolById(id: $id){ reportAccess }');
export const school_progressReports = buildGqlQuery('school_progressReports', vars, 'schoolById(id: $id){ district{ hasProgressReports } }');
export const school_usageReports = buildGqlQuery('school_usageReports', vars, 'schoolById(id: $id){ district{ hasUsageReports } }');
const klass = buildGqlQuery('reports_class', vars, 'classById(id: $id){ id }');
const user = buildGqlQuery('reports_user', vars, 'userById(id: $id){ id }');

export default {
  'reports': anyone,
  'reports/search': anyone,

  'reports/program/community': program,
  'reports/program/growth': program,
  'reports/program/leaderboards': program,
  'reports/program/overview': program,
  'reports/program/proficiency': program,
  'reports/program/progress': async (...args) => {
    const [programAc, flag, isAdmin] = await Promise.all([
      program(...args),
      program_progressReports(...args),
      adminOnly(...args),
    ]);
    return (programAc && (flag || isAdmin));
  },

  'reports/district/community': district_nonDistrictSchools,
  'reports/district/community-details': district_nonDistrictSchools,
  'reports/district/leaderboards': district,
  'reports/district/growth': district_districtSchools,
  'reports/district/overview': district,
  'reports/district/proficiency': district_districtSchools,
  'reports/district/progress': async (...args) => {
    const [districtAc, flag, isAdmin] = await Promise.all([
      district(...args),
      district_progressReports(...args),
      adminOnly(...args),
    ]);
    return (districtAc && (flag || isAdmin));
  },
  'reports/district/unassigned': district_nonDistrictSchools,
  'reports/district/usage': async (...args) => {
    const [districtAc, flag, isAdmin] = await Promise.all([
      district(...args),
      district_usageReports(...args),
      adminOnly(...args),
    ]);
    return (districtAc && (flag || isAdmin));
  },

  'reports/class/activities': klass,
  'reports/class/attendance': klass,
  'reports/class/assignments-gradebook': klass,
  'reports/class/shared-links': klass,
  'reports/class/proficiency': klass,
  'reports/class/groups': klass,
  'reports/class/growth': klass,
  'reports/class/overview': klass,
  'reports/class/usage': klass,
  'reports/class/writing': klass,
  'reports/class/progress': klass,

  'reports/school/growth': school,
  'reports/school/leaderboard': school,
  'reports/school/proficiency': school,
  'reports/school/progress': async (...args) => {
    const [schoolAc, flag, isAdmin] = await Promise.all([
      school(...args),
      school_progressReports(...args),
      adminOnly(...args),
    ]);
    return (schoolAc && (flag || isAdmin));
  },
  'reports/school/overview': school,
  'reports/school/unassigned': school,
  'reports/school/usage': async (...args) => {
    const [schoolAc, flag, isAdmin] = await Promise.all([
      school(...args),
      school_usageReports(...args),
      adminOnly(...args),
    ]);
    return (schoolAc && (flag || isAdmin));
  },

  'reports/student/activity-log': user,
  'reports/student/assessment_wc-preview': user,
  'reports/student/assignments': user,
  'reports/student/shared-links': user,
  'reports/student/growth': user,
  'reports/student/overview': user,
  'reports/student/reading-log': user,
  'reports/student/usage': user,
  'reports/student/writing-log': user,
  'reports/student/proficiency': user,
  'reports/student/writing_wc-preview': user,
  'reports/student/progress': user,

  'reports/user/overview': user,
};
